/**
 * Goldmine condition grading for records — the full eight-grade scale, not
 * the abbreviated five, because Discogs's collection CSV export emits all
 * eight and a narrower enum would force a lossy mapping at import time.
 *
 * The enum identifiers can't hold "+" (Prisma/Postgres identifier rules), so
 * VG_PLUS ⇄ "VG+" lives here and nowhere else. Grade strings are a standard
 * and are deliberately not translated.
 */

/** Best to worst — the picker renders this order. */
export const CONDITIONS = ["M", "NM", "VG_PLUS", "VG", "G_PLUS", "G", "F", "P"] as const;

export type Condition = (typeof CONDITIONS)[number];

export const CONDITION_LABELS: Record<Condition, string> = {
  M: "M",
  NM: "NM",
  VG_PLUS: "VG+",
  VG: "VG",
  G_PLUS: "G+",
  G: "G",
  F: "F",
  P: "P",
};

export const CONDITION_NAMES: Record<Condition, string> = {
  M: "Mint",
  NM: "Near Mint",
  VG_PLUS: "Very Good Plus",
  VG: "Very Good",
  G_PLUS: "Good Plus",
  G: "Good",
  F: "Fair",
  P: "Poor",
};
